import React from 'react'
import { connect } from 'react-redux'
import SecondaryButton from '../SecondaryButton/SecondaryButton'
import Modal from '../Modal/Modal'

const ApplicationModal = ({ open, existingApplication, onAbandon, onCloseModal, newApplication, product }) => (
  <Modal open={open} onCloseModal={() => onCloseModal()}>
  
    <h1 className="modal__title">{`Produto ${product}: Regra de Aplicação`}</h1>
    <p className="modal__description" style={{fontSize: 14, lineHeight: 2}}>
    Você tentou adicionar o tipo de aplicação
    <span style={{color:'#04223B'}}>{` ${newApplication}, `}</span>
     mas o Produto
     <span style={{color:'#04223B'}}>{` ${product} `}</span>
     já tem o tipo
    <span style={{color:'#04223B'}}>{` ${existingApplication} `}</span>
     neste pedido. <br></br>
     <span style={{fontWeight:'bold'}}>Lembre-se: </span>
     Apenas um tipo de aplicação é permitido por produto e pedido.<br></br>
     <span style={{fontWeight:'bold'}}>Ação: </span>
     Separe a nova aplicação em outro pedido.
    </p>
 
    
{/*     <PrimaryButton onClick={onContinue}>Fechar</PrimaryButton> */}
    <SecondaryButton onClick={onAbandon}>Fechar</SecondaryButton>
  </Modal>
)

const mapStateToProps = state => ({
  selected: state.farm.selected,
})

export default connect(mapStateToProps)(ApplicationModal)
